import React from 'react';
import Tooltip, {TooltipProps} from '@material-ui/core/Tooltip';

/**
 * TODO: style me
 *
 * @param props
 * @constructor
 */
const EvTooltip: React.FC<TooltipProps> = props => {
  return <Tooltip {...props}>{props.children}</Tooltip>;
};

export default EvTooltip;
